import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _actionCommandHandler;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { PLATFORM } from '../../../constants';
import useNotificationsPermissions from '../../../screens/DynamicPopups/hooks/useNotificationsPermissions';
import { deleteTriggerNotify, postToggleMarketingEmails, postTriggersNotify, postToggleNotifications } from '../../../state/query/actionCommands';
import { clearLastActionCommand } from '../../../state/slices/actionCommands/actionCommands';
import store from '../../../state/store';
import utils from '../../../utils';
import { sendActionCommandsEvent } from '../analytics';
import { ACTION_COMMANDS_EVENT_TYPE } from '../constants';
import { ACTION_COMMANDS_TYPE } from '../constants/types';

var handleNotifyTriggerProcessedRequest = function handleNotifyTriggerProcessedRequest(_ref) {
  var event = _ref.event,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? null : _ref$modalType,
      triggerExecution = _ref.triggerExecution,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? null : _ref$payload,
      _ref$isFtueFlow = _ref.isFtueFlow,
      isFtueFlow = _ref$isFtueFlow === void 0 ? null : _ref$isFtueFlow;
  event && sendActionCommandsEvent[event](modalType, triggerExecution, payload, isFtueFlow);
  store.dispatch(postTriggersNotify.initiate(_objectSpread({
    executionId: triggerExecution === null || triggerExecution === void 0 ? void 0 : triggerExecution.executionId
  }, payload && {
    payload: payload
  })));
};

var handleNotifyTriggerDismissedRequest = function handleNotifyTriggerDismissedRequest(_ref2) {
  var executionId = _ref2.executionId;
  return store.dispatch(deleteTriggerNotify.initiate({
    executionId: executionId
  }));
};

var handleAllowMarketingEmailsRequest = function handleAllowMarketingEmailsRequest(_ref3) {
  var allowMarketingEmails = _ref3.onClickAction.allowMarketingEmails,
      _ref3$modal = _ref3.modal,
      onDisplayAction = _ref3$modal.onDisplayAction,
      modalType = _ref3$modal.modalType;
  sendActionCommandsEvent[ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL](modalType, onDisplayAction.triggerExecution);
  store.dispatch(postToggleMarketingEmails.initiate({
    allowMarketingEmails: allowMarketingEmails
  }));
};

var handleAllowNotificationsRequest = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
    var allowNotifications, _ref4$modal, onDisplayAction, modalType, _useNotificationsPerm, requestNativePermissions, nativePermissions;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            allowNotifications = _ref4.onClickAction.allowNotifications, _ref4$modal = _ref4.modal, onDisplayAction = _ref4$modal.onDisplayAction, modalType = _ref4$modal.modalType;

            if (!(utils.getPlatform() !== PLATFORM.WEB)) {
              _context.next = 10;
              break;
            }

            sendActionCommandsEvent[ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL](modalType, onDisplayAction.triggerExecution);
            _useNotificationsPerm = useNotificationsPermissions(), requestNativePermissions = _useNotificationsPerm.requestNativePermissions;
            _context.next = 6;
            return requestNativePermissions(modalType, onDisplayAction);

          case 6:
            nativePermissions = _context.sent;
            if (nativePermissions) store.dispatch(postToggleNotifications.initiate({
              allowNotifications: allowNotifications
            }));
            _context.next = 11;
            break;

          case 10:
            store.dispatch(postToggleNotifications.initiate({
              allowNotifications: allowNotifications
            }));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleAllowNotificationsRequest(_x) {
    return _ref5.apply(this, arguments);
  };
}();

var handleSubmitEventRequest = function handleSubmitEventRequest(_ref6) {
  var event = _ref6.event,
      modalType = _ref6.modalType,
      onDisplayAction = _ref6.onDisplayAction;
  return sendActionCommandsEvent[event](modalType, onDisplayAction);
};

var handleClearActionCommands = function handleClearActionCommands() {
  return store.dispatch(clearLastActionCommand());
};

export var actionCommandHandler = (_actionCommandHandler = {}, _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST, handleNotifyTriggerProcessedRequest), _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_DISMISSED_REQUEST, handleNotifyTriggerDismissedRequest), _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.TOGGLE_ALLOW_NOTIFICATIONS_REQUEST, handleAllowNotificationsRequest), _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.TOGGLE_ALLOW_MARKETING_EMAILS_REQUEST, handleAllowMarketingEmailsRequest), _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.SUBMIT_EVENT_REQUEST, handleSubmitEventRequest), _defineProperty(_actionCommandHandler, ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND, handleClearActionCommands), _actionCommandHandler);